import React from 'react';
import '../../App.css';
import ChallanForm from '../ChallanForm'

function Challan({ sessionObject, itemNamesDict }) {
  if(!sessionObject.sessionVariables["modules"].includes("challan")){
    return;}
  return (
    <div className="page-challan">
      <ChallanForm sessionObject={sessionObject} itemNamesDict={itemNamesDict} />
    </div>
  );
}

export default Challan;